import React from 'react'

import LoginForm from '../../components/loginform'

const LoginPage = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <LoginForm />
    </div>
  )
}

export default LoginPage